import { render, staticRenderFns } from "./Chamados.vue?vue&type=template&id=6f3eb1cc&scoped=true"
import script from "./Chamados.vue?vue&type=script&lang=js"
export * from "./Chamados.vue?vue&type=script&lang=js"
import style0 from "./Chamados.vue?vue&type=style&index=0&id=6f3eb1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3eb1cc",
  null
  
)

export default component.exports